import { useMemo } from 'react';
import useWindowDimensions from 'collaboration-sidebar/hooks/useWindowDimensions';
import { DEFAULT_WIDTH_CUTOFF } from '../constants/sidebar';
export default function useIsScreenWidthBelowThreshold() {
  const {
    width
  } = useWindowDimensions();
  const isScreenWidthBelowThreshold = useMemo(() => width < DEFAULT_WIDTH_CUTOFF, [width]);
  return isScreenWidthBelowThreshold;
}